export const DEFAULT_STATEMENT_ACTIVITY_LOOKBACK = { amount: 30, unit: `days` };
/** Both are 3 years */
export const MAX_STATEMENT_ACTIVITY_LOOKBACK = { days: 1096, months: 36 };
export function isValidStatementActivityLookback(value) {
    const { amount, unit } = (value !== null && value !== void 0 ? value : {});
    return (unit === `days` || unit === `months`)
        && Number.isInteger(amount)
        && amount >= 1
        && amount <= MAX_STATEMENT_ACTIVITY_LOOKBACK[unit];
}
export const MAX_STATEMENT_AGED_BREAKPOINTS = 3;
export const MAX_STATEMENT_AGED_BREAKPOINT_DAYS = 3650;
export const MAX_STATEMENT_SPLIT_ON_DUE_INDEX_DAYS = 365;
export function isValidStatementTemplateOptions(value) {
    const { agedBreakpoints, splitOnDue, splitOnDueIndex } = (value !== null && value !== void 0 ? value : {});
    return Array.isArray(agedBreakpoints)
        && agedBreakpoints.length <= MAX_STATEMENT_AGED_BREAKPOINTS
        && agedBreakpoints.every((days, i) => Number.isInteger(days)
            && days >= 1
            && days <= MAX_STATEMENT_AGED_BREAKPOINT_DAYS
            && (i === 0 || days > agedBreakpoints[i - 1]))
        && typeof splitOnDue === `boolean`
        && Number.isInteger(splitOnDueIndex)
        && Math.abs(splitOnDueIndex) <= MAX_STATEMENT_SPLIT_ON_DUE_INDEX_DAYS;
}
//# sourceMappingURL=statementBuilder.js.map